export default __webpack_public_path__ + "static/media/threejs.a02bc572.svg";